import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import {
  InputNumber, ErrorField,
} from '../../../../lib/HooksFormFields';
import styles from './investment.module.scss';
import { kpis } from '../../../../utils';

const Investment = () => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const { activation } = useOutletContext<any>();
  const arrayKPIs = kpis.investment

  if(!activation || (!activation.market && !activation.maison && !activation.activationType && !activation.year)) return null;

  return (
    <div className={styles.investment}>
      <h1>Investment</h1>
      <div className={styles['investment-line']}>
        <div className={styles['investment-col']}>
        </div>
        <div className={styles['investment-col']}>
          <p className={styles['col-label']}>Actual</p>
        </div>
        <div className={styles['investment-col']}>
          <p className={styles['col-label']}>Planned</p>
        </div>
      </div>
      <div className={styles['investment-line']}>
        <div className={styles['investment-col']}>
          <p>Total investment</p>
        </div>
        <div className={styles['investment-col']}>
          <InputNumber
            name="totalInvestmentActual"
            placeholder=''
            control={control}
          />
          {errors?.totalInvestmentActual && <ErrorField
            message={errors?.totalInvestmentActual?.message}
          />}
        </div>
        <div className={styles['investment-col']}>
          <InputNumber
            name="totalInvestmentPlanned"
            placeholder=''
            control={control}
          />
          {errors?.totalInvestmentPlanned && <ErrorField
            message={errors?.totalInvestmentPlanned?.message}
          />}
        </div>
      </div>

      {arrayKPIs.map((kpi, index) => (
        <div className={styles['investment-line']} key={`kpi-line-${index}`}>
          <div className={styles['investment-col']}>
            <p>{kpi.label}</p>
          </div>
          <div className={styles['investment-col']}>
            <InputNumber
              name={kpi.value}
              placeholder=''
              control={control}
            />
            {errors?.[kpi.value] && <ErrorField
              message={errors?.[kpi.value]?.message}
            />}
          </div>
          <div className={styles['investment-col']}>
          </div>
        </div>
      ))}

      <div className={styles.separator}></div>
    </div>
  );
};

export default Investment;
